import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { OrderMetadata } from '@/screens/order-inbounds/types';

interface InboundMetadataRowsContextType {
  orders: OrderMetadata[];
}

const InboundMetadataRowsContext =
  createContext<InboundMetadataRowsContextType | null>(null);

export const InboundMetadataRowsProvider: React.FC<{
  children: ReactNode;
  orders: OrderMetadata[];
}> = ({ children, orders }) => {
  const contextValue = useMemo<InboundMetadataRowsContextType>(
    () => ({ orders }),
    [orders],
  );

  return (
    <InboundMetadataRowsContext.Provider value={contextValue}>
      {children}
    </InboundMetadataRowsContext.Provider>
  );
};

export const useInboundMetadataRows = () => {
  const context = useContext(InboundMetadataRowsContext);
  if (!context) {
    throw new Error(
      'useInboundMetadataRows must be used within an InboundMetadataRowsProvider',
    );
  }
  return context;
};
